import shortid from 'shortid'
import ls from 'local-storage'
import * as api from '../../requests'

export const setMyReceipts = (rows, template) => ({
  type: 'SET_MY_RECEIPTS',
  rows,
  template,
})

export const setReceiptsError = (error) => ({ type: 'SET_MY_RECEIPTS_ERROR', error })

export const setMyReceiptDetailsError = (error) => ({ type: 'SET_MY_RECEIPT_DETAIL_ERROR', error })

export const setReceiptsErrorDetails = (errorDetail) => ({
  type: 'SET_MY_RECEIPTS_ERROR_DETAILS',
  errorDetail,
})

export const setMyReceiptsDetailErrorMessage = (errorDetail) => ({
  type: 'SET_MY_RECEIPT_DETAIL_ERROR_MESSAGE',
  errorDetail,
})

export const setReceiptsLoading = (loading) => ({
  type: 'SET_MY_RECEIPTS_LOADING',
  loading,
})

export const setMyReceiptDetailsLoading = (loading) => ({
  type: 'SET_MY_RECEIPT_DETAIL_LOADING',
  loading,
})

export const setLastRequestId = (reqId) => ({
  type: '@@mrcpt/SET_REQUEST_ID',
  reqId,
})

export const setFilters = (category, filters) => (dispatch, getState) => {
  dispatch({
    type: '@@mrcpt/SET_FILTERS',
    category,
    filters,
  })
  ls.set('MY_RECEIPTS_FILTERS', { ...getState().myReceipts.filters, [category]: filters })
}

export const setMyReceiptsSelectedReceipt = (details) => ({
  type: 'SET_MY_RECEIPTS_SELECTED_RECEIPT',
  details,
})

export const setMyReceiptDetails = (details) => ({
  type: 'SET_MY_RECEIPT_DETAILS',
  details,
})

export const selectMyReceiptsRow = (selected, row) => ({
  type: 'SELECT_MY_RECEIPTS_ROW',
  selected,
  row,
})

export const selectMyReceiptRecord = (selected) => ({
  type: 'SELECT_MY_RECEIPT_RECORD',
  selected,
})

export const selectMyReceiptsRowAndGetDetails = (id, row) => (dispatch) => {
  dispatch(selectMyReceiptsRow(id, row))
}

export const pullAndSetMyReceipts = (category) => (dispatch, getState) => {
  dispatch(setReceiptsLoading(true))
  dispatch(setReceiptsError(false))
  dispatch(setReceiptsErrorDetails({ message: null, code: null }))
  const parameters = getState().myReceipts.filters.myReceipts || {
    SEARCH: '',
    DATE_RANGE: {
      start: null,
      end: null,
    },
    REF_NUM: '',
    RECEIPT_NUM: '',
    DESCRIPTION: '',
    AMOUNT: '',
    TYPE: '',
  }
  const requestId = shortid.generate()
  dispatch(setLastRequestId(requestId))

  api.GET_MY_RECEIPTS(
    requestId,
    parameters,
    (data, props = {}) => {
      dispatch(setReceiptsLoading(false))
      dispatch(setMyReceipts(data.rows, data.template))
    },
    (err) => {
      dispatch(setReceiptsLoading(false))
      dispatch(setReceiptsError(true))
      dispatch(setReceiptsErrorDetails({ message: err.Message, code: err.Code }))
    }
  )
}

export const pullAndSetReceiptDetails = (category) => (dispatch, getState) => {
  const requestId = shortid.generate()
  const parameters = getState()
  dispatch(setMyReceiptDetails([]))
  dispatch(setMyReceiptDetailsLoading(true))

  api.GET_MY_RECEIPTS_DETAILS(
    requestId,
    parameters.myReceipts.selectedReceipt.RECEIPT_ID,
    (data, props = {}) => {
      dispatch(setMyReceiptDetailsLoading(false))
      dispatch(setMyReceiptDetails(data))
    },
    (err) => {
      dispatch(setMyReceiptDetailsLoading(false))
      dispatch(setMyReceiptDetailsError(true))
      dispatch(setMyReceiptsDetailErrorMessage({ message: err.Message, code: err.Code }))
    }
  )
}



// WEBPACK FOOTER //
// ./src/components/MyReceipts/MyReceiptsActions.js